import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Grain from "@/components/Grain";
import Home from "@/pages/Home";
import Story from "@/pages/Story";
import Menu from "@/pages/Menu";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";

const Page = ({ children }) => (
  <motion.main
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.main>
);

function LineSweep() {
  return (
    <motion.div
      className="fixed top-0 left-0 z-[80] h-[2px] bg-gold origin-left"
      initial={{ scaleX: 0, opacity: 1 }}
      animate={{ scaleX: 1, opacity: 0 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      style={{ width: "100%" }}
    />
  );
}

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <div key={location.pathname}>
        <LineSweep />
        <Routes location={location}>
          <Route path="/" element={<Page><Home /></Page>} />
          <Route path="/story" element={<Page><Story /></Page>} />
          <Route path="/menu" element={<Page><Menu /></Page>} />
          <Route path="/gallery" element={<Page><Gallery /></Page>} />
          <Route path="/contact" element={<Page><Contact /></Page>} />
        </Routes>
      </div>
    </AnimatePresence>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll />
        <Grain />
        <Nav />
        <AnimatedRoutes />
        <Footer />
        <Toaster position="top-center" theme="dark" />
      </BrowserRouter>
    </div>
  );
}
